import {Component, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {Session} from "../../services/Session";
import {LoadingService} from "../../services/LoadingService";
import {ToastService} from "../../services/Toast.service";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {FormulaTestCaseService} from "../../tpiq-services/formula-test-case.service";
import {buildInputJsonFromFormula, detectFormulaVariables} from "../formula-variable-detector";

@Component({
  selector: 'app-formula-sandbox',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './formula-sandbox.component.html',
  styleUrl: './formula-sandbox.component.scss'
})
export class FormulaSandboxComponent implements OnInit {
  org: string;
  user: string;

  formulaType = 'BOOLEAN';
  formula = '';
  inputValuesText = '';
  jsonError = '';

  result: any = null;
  evaluating = false;

  constructor(
    private loadingService: LoadingService,
    private toastService: ToastService,
    private formulaTestCaseService: FormulaTestCaseService
  ) {
  }

  ngOnInit(): void {
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
  }

  detectVariables() {
    if (!this.formula || !this.formula.trim()) {
      this.toastService.pop(TOAST_TYPE.error, 'Formula is required');
      return;
    }
    const variables = detectFormulaVariables(this.formula);
    if (!variables.length) {
      this.toastService.pop(TOAST_TYPE.info, 'No variables detected in this formula');
      return;
    }
    this.inputValuesText = buildInputJsonFromFormula(this.formula, this.inputValuesText);
    this.jsonError = '';
  }

  validateJson(): boolean {
    if (!this.inputValuesText || !this.inputValuesText.trim()) {
      this.jsonError = '';
      return true;
    }
    try {
      JSON.parse(this.inputValuesText);
      this.jsonError = '';
      return true;
    } catch (e) {
      this.jsonError = 'Input values must be valid JSON';
      return false;
    }
  }

  evaluate() {
    if (!this.formula || !this.formula.trim()) {
      this.toastService.pop(TOAST_TYPE.error, 'Formula is required');
      return;
    }
    if (!this.validateJson()) {
      return;
    }

    const payload = {
      formulaType: this.formulaType,
      formula: this.formula,
      inputValues: this.inputValuesText
    };

    this.evaluating = true;
    this.result = null;
    this.loadingService.triggerLoadingEvent(true);
    this.formulaTestCaseService.evaluateSandbox(this.org, this.user, payload).subscribe((response) => {
      this.evaluating = false;
      this.loadingService.triggerLoadingEvent(false);
      this.result = response;
    }, (error) => {
      this.evaluating = false;
      this.loadingService.triggerLoadingEvent(false);
      this.result = {passed: false, errorMessage: error.message || 'Evaluation failed'};
    });
  }
}
